import axios from 'axios';
import { DonationURL } from '../../../../config/UrlEndPoint';
import { URL } from "../../../Donatur/_redux/donatur/donaturCrud";

export const DONATION_URL = `${DonationURL}donation`;

// items => filtered/sorted result
export function findDonations(queryParams) {
    return axios.post(`${DONATION_URL}/find`, queryParams);
}

//Get By ID
export function getDonationById(donationId) {
    return axios.get(`${DONATION_URL}/${donationId}`);
}

//Get File By file_trx_uuid
export function getFileById(fileId) {
    return axios.get(`${DONATION_URL}/file/${fileId}`);
}

//Create Donation Counter
export function createDonation(donationData) {
    return axios.post(`${DONATION_URL}`, donationData);
}

//Post Donation Item
export function putDonationItem(donationItem, donationId) {
    return axios.put(`${DONATION_URL}/donationitem/${donationId}`, donationItem);
}

export function putDonationPayment(donationPayment, donationId) {
    return axios.put(`${DONATION_URL}/donation_payment/${donationId}`, { donation_payment: donationPayment });
}

// URL update batch data donatur
export function updateDonatur(payload) {
    return axios.put(`${DONATION_URL}/update_donor`, payload);
}

// URL REQUEST VOID
export function requestVoid(data) {
    return axios.put(`${DONATION_URL}/void/request`, data);
}

//Get By ID
export function getKurbanList() {
    return axios.get(`${DonationURL}livestock`);
}

//Generate EXCEL
export function generateReport(payload) {
    return axios.post(`${DONATION_URL}/report`, payload, { responseType: 'arraybuffer' });

}

// UPDATE SETTLE
export function updateStatus(id) {
    return axios.put(`${DONATION_URL}/settle/${id}`);
}

export function sendNotification(id, email, hp) {
    return axios.post(`${DONATION_URL}/send_notification`, { id: id, email: email, hp: hp })
}

export function exportDonation(value) {
    return axios.post(`${DONATION_URL}/report`, value)
}

//Get By ID
export function getDonationNotificationById(donationId) {
    return axios.get(`${DONATION_URL}/notification/${donationId}`);
}

//Change Date
export function updateDonationDateChannel(data, uuid) {
    return axios.put(`${DONATION_URL}/update_donation_date_channel`, { ...data, uuid });
}

export function updateDonationDepartment(uuid, department_uuid) {
    return axios.put(`${DONATION_URL}/update_donation_department`, { uuid, department_uuid });
}

export function exportDonationMitra(value) {
    return axios.post(`${DONATION_URL}/download_export_donation_mitra`, value, { responseType: 'arraybuffer' })
}


export function changeStatusConfirm(value) {
    return axios.post(`${DONATION_URL}/donation_commit`, { uuid: value })
}


export function findDonationPayments(queryParams) {
    return axios.post(`${DONATION_URL}/donation_payment/find`, queryParams);
}